import { render } from "./WineryListPage.vue?vue&type=template&id=e48e105e&scoped=true"
import script from "./WineryListPage.vue?vue&type=script&lang=js"
export * from "./WineryListPage.vue?vue&type=script&lang=js"

import "./WineryListPage.vue?vue&type=style&index=0&id=e48e105e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e48e105e"

export default script